import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import GridCircularProgress from '../components/GridCircularProgress'
import { useGetIscrizioniQuery } from '../hooks/api-slice'
import { useTeamName } from '../hooks/utils-functions'

const GridMatchInfo = ({ gara, info, children }) => {
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )

  const { isFetching } = useGetIscrizioniQuery(
    { campionato: selectedCampionato, iFilter: 'nomi' },
    { skip: !selectedCampionato },
  )

  const squadraCasaName = useTeamName(gara?.squadraCasaID)
  const squadraTrasfertaName = useTeamName(gara?.squadraTrasfertaID)

  if (isFetching) return <GridCircularProgress />

  if (!gara) return <Grid size={12}>Nessuna partita selezionata.</Grid>

  return (
    <Grid
      container
      spacing={2}
      alignItems='center'
      justifyContent='center'
      sx={{ width: '100%' }}
    >
      {info && <Grid size={12}>{info}</Grid>}
      <Grid size={{ xs: 12, md: 6 }}>
        <center>
          <b>{squadraCasaName}</b>&nbsp;-&nbsp;<b>{squadraTrasfertaName}</b>
        </center>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <center>{gara?.data || 'Data non definita'}</center>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <center>{gara?.ora || 'Ora non definita'}</center>
      </Grid>
      {children}
    </Grid>
  )
}

export default GridMatchInfo
